import React, { Component } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { MedForm, YesOrNo, Frequency } from '../classes/medForm';
import { displayingDate } from '../utils';

class Question extends Component<{ question: string; answer: string; values?: string[] }> {
  render() {
    let answer: JSX.Element;
    if (!this.props.values) {
      answer = <p className='blue-dark-color'>{this.props.answer}</p>;
    } else {
      const valueElements: JSX.Element[] = [];
      for (const value of this.props.values) {
        valueElements.push(
          <ToggleButton value={value} key={value} variant='outline-secondary'>
            {value}
          </ToggleButton>,
        );
      }
      answer = (
        <div className='mb-2'>
          <ToggleButtonGroup name='value' type='radio' value={this.props.answer}>
            {valueElements}
          </ToggleButtonGroup>
        </div>
      );
    }
    return (
      <div className='row'>
        <div className='col-6 bold blue-dark-color'>{this.props.question}</div>
        <div className='col-6'>{answer}</div>
      </div>
    );
  }
}

class Form extends Component<{ medForm: MedForm }> {
  render() {
    return (
      <div>
        <Question
          question='Date du dernier rendez-vous :'
          answer={displayingDate(this.props.medForm.latestConsultationDate, 'fr', false, false)}
        />
        <Question question='Brossage des dents :' answer={this.props.medForm.teethBrushing} values={Object.values(YesOrNo)} />
        <Question
          question='Fréquence de brossage des dents :'
          answer={this.props.medForm.teethBrushingFrequency}
          values={Object.values(Frequency)}
        />
        <Question question='Antécédents médicaux :' answer={this.props.medForm.medicalHistory} />
        <Question question='Traitements médicaux :' answer={this.props.medForm.treatments} />
      </div>
    );
  }
}

export { Form };
